export const loginToken = 'AIzaSyAalNjiRVaF8VkiKhzIWqqBx11_Ga784m0';
export const registerToken = 'AIzaSyAalNjiRVaF8VkiKhzIWqqBx11_Ga784m0';
